import { system } from 'styled-system';

const borderTopStyle = system({
  borderTopStyle: {
    property: 'borderTopStyle',
  },
});

export default borderTopStyle;
